// Attack type catalog (SF-97/SF-96). Unit offense/defense point tables and the Calculator-only
// formulas that used them (calculateOffensePoints, calculateSuccessRate, optimizeArmy) were
// removed with AttackCalculatorTab.tsx's retirement (SF-147) — War Room's own MWF solver
// (utils/minimumWinningForce.ts) is the sole source of truth for offense math now.

// Attack types
export const ATTACK_TYPES = {
  TRADITIONAL_MARCH: {
    id: 'TRADITIONAL_MARCH',
    name: 'Traditional March',
    description: 'Standard attack to capture land',
    enabled: true,
  },
  PLUNDER: {
    id: 'PLUNDER',
    name: 'Plunder',
    description: 'Raid for resources',
    enabled: true,
  },
  RAZE: {
    id: 'RAZE',
    name: 'Raze',
    description: 'Destroy enemy buildings',
    enabled: true,
  },
  LEARN: {
    id: 'LEARN',
    name: 'Learn',
    description: 'Steal science books',
    enabled: true,
  },
  MASSACRE: {
    id: 'MASSACRE',
    name: 'Massacre',
    description: 'Kill enemy population',
    enabled: true,
  },
  CONQUEST: {
    id: 'CONQUEST',
    name: 'Conquest',
    description: 'Full province takeover',
    enabled: true,
  },
  AMBUSH: {
    id: 'AMBUSH',
    name: 'Ambush',
    description: 'Recapture land from a province that recently raided you',
    enabled: true,
  },
} as const;
